<div class="container mx-auto position-footer">
  <img [src]="resource.footer.brand" />
  <p class="textBInfoBottom text-center">
    <a style="cursor: pointer" (click)="goToLink(resource.footer.url)">{{
      resource.footer.text
    }}</a>
  </p>
</div>

